import { Spinner } from "reactstrap";

export const LoadingIcon = ({ className, ...props }) => <Spinner size="sm" className={className} {...props} />;

LoadingIcon.displayName = "LoadingIcon";
